import { formatNumber, KpiGrid, KpiTile } from '@platform/design-system';
import type { TypedClient } from '@platform/openapi';
import { useProductCounts } from '../catalog/useCatalogQueries.ts';
import { useStockOverview } from '../dashboard/stock.ts';
import { usePageContext } from '../usePageContext.ts';

const DEPOT_SEPARATOR = ' · ';

export const InventoryKpis = ({ api }: { api: TypedClient }) => {
  const { t, locale } = usePageContext();
  const stock = useStockOverview(api, null).data;
  const products = useProductCounts(api, { company: null, operationWindow: null }).data;
  const count = (value: number | undefined) =>
    value === undefined ? undefined : formatNumber(value, locale);
  const totals = stock?.totals;
  return (
    <KpiGrid columns={4}>
      <KpiTile
        emphasis="hero"
        label={t('inventory.kpi_available')}
        loading={stock === undefined}
        value={count(totals?.available)}
        hint={stock?.depots
          .map((depot) => `${depot.name} ${formatNumber(depot.available, locale)}`)
          .join(DEPOT_SEPARATOR)}
      />
      <KpiTile
        label={t('inventory.kpi_variants')}
        loading={stock === undefined}
        value={count(totals?.variants)}
        hint={
          products === undefined
            ? undefined
            : t('inventory.kpi_inProducts', {
                count: products.all,
                total: formatNumber(products.all, locale),
              })
        }
      />
      <KpiTile
        label={t('inventory.kpi_low')}
        tone="warning"
        loading={stock === undefined}
        value={count(totals?.low)}
        hint={t('inventory.kpi_lowHint')}
      />
      <KpiTile
        label={t('inventory.kpi_out')}
        tone="danger"
        loading={stock === undefined}
        value={count(totals?.out)}
        hint={t('inventory.kpi_outHint')}
      />
    </KpiGrid>
  );
};
